import React from 'react';

const FarmaciIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 11.125C10.4142 11.125 10.75 11.4608 10.75 11.875V12.625H11.5C11.9142 12.625 12.25 12.9608 12.25 13.375C12.25 13.7892 11.9142 14.125 11.5 14.125H10.75V14.875C10.75 15.2892 10.4142 15.625 10 15.625C9.58579 15.625 9.25 15.2892 9.25 14.875V14.125H8.5C8.08579 14.125 7.75 13.7892 7.75 13.375C7.75 12.9608 8.08579 12.625 8.5 12.625H9.25V11.875C9.25 11.4608 9.58579 11.125 10 11.125Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.948 0.625001C9.04953 0.624973 8.3003 0.624949 7.70552 0.704914C7.07773 0.789319 6.51093 0.97499 6.05546 1.43046C5.59999 1.88593 5.41432 2.45273 5.32991 3.08052C5.24995 3.6753 5.24997 4.42452 5.25 5.323L5.25 5.40072C3.22882 5.46685 2.01511 5.70303 1.17157 6.54658C0 7.71815 0 9.60377 0 13.375C0 17.1462 0 19.0319 1.17157 20.2034C2.34314 21.375 4.22876 21.375 7.99998 21.375H12C15.7712 21.375 17.6569 21.375 18.8284 20.2034C20 19.0319 20 17.1462 20 13.375C20 9.60377 20 7.71815 18.8284 6.54658C17.9849 5.70303 16.7712 5.46685 14.75 5.40072L14.75 5.32301C14.75 4.42454 14.7501 3.6753 14.6701 3.08052C14.5857 2.45273 14.4 1.88593 13.9445 1.43046C13.4891 0.97499 12.9223 0.789319 12.2945 0.704914C11.6997 0.624949 10.9505 0.624973 10.052 0.625001H9.948ZM13.25 5.37689V5.375C13.25 4.41099 13.2484 3.76343 13.1835 3.2804C13.1214 2.81893 13.0142 2.62144 12.8839 2.49112C12.7536 2.3608 12.5561 2.25358 12.0946 2.19154C11.6116 2.1266 10.964 2.125 10 2.125C9.03599 2.125 8.38843 2.1266 7.90539 2.19154C7.44393 2.25358 7.24643 2.3608 7.11612 2.49112C6.9858 2.62144 6.87858 2.81893 6.81654 3.2804C6.75159 3.76343 6.75 4.41099 6.75 5.375V5.37689C7.14203 5.375 7.55807 5.375 8 5.375H12C12.4419 5.375 12.858 5.375 13.25 5.37689ZM14 13.375C14 15.5841 12.2091 17.375 10 17.375C7.79086 17.375 6 15.5841 6 13.375C6 11.1659 7.79086 9.375 10 9.375C12.2091 9.375 14 11.1659 14 13.375Z"
        fill={fill}
      />
    </svg>
  );
};

export default FarmaciIcon;
